module.exports = __webpack_public_path__ + "static/media/nparks1.1d2dc784.png";